module.exports = __webpack_public_path__ + "static/media/ab2.79c2ad2d.png";